import {
  parseSearchArrayValue,
  parseSearchBooleanValue,
  parseSearchNumberValue,
  parseSearchStringValue,
} from 'infrastructure/functions/parse-query-string';

import { useQueryFilterNew } from '../common/use-query-param-new';

import type { TParseFunctions } from '../common/use-query-param-new';
import type { ISmsCampaignsProgressFilters } from 'infrastructure/interfaces';

const defaultFilter: ISmsCampaignsProgressFilters = {
  page: 1,
  patientKey: 'fullName',
};

const parseFunctions: TParseFunctions<ISmsCampaignsProgressFilters> = {
  page: parseSearchNumberValue,
  patientGuid: parseSearchStringValue,
  patientLabel: parseSearchStringValue,
  patientKey: parseSearchStringValue,
  campaignGuid: parseSearchStringValue,
  status: parseSearchStringValue,
  nameSort: parseSearchStringValue,
  available: parseSearchBooleanValue,
  timezone: parseSearchArrayValue,
};

export const useSmsCampaignsProgressQueryFilter = () => {
  return useQueryFilterNew<ISmsCampaignsProgressFilters>(
    defaultFilter,
    parseFunctions,
    ['page', 'patientLabel', 'patientKey', 'campaignGuid', 'nameSort'],
  );
};
